import { useCallback } from 'react';
import { CanceledError } from 'axios';
import { useRouter } from 'next/router';

import { isIgnoreError } from '@/api/apiUtil';
import { useUserLocalStorageState } from '@/lib/auth/hooks/useUserLocalStorageState';
import { TranslationAbortController } from '@/module/play/hook/translation';
import { combinePathAndQuery } from '@/utils/combinePathAndQuery';

export const useApiError = () => {
  const router = useRouter();
  const { clearUser } = useUserLocalStorageState();

  const goLoginPage = useCallback(async () => {
    clearUser();
    if (router.isReady && router.asPath) {
      if (!router.query['callbackUrl'] && router.asPath !== '/login') {
        router.query['callbackUrl'] = router.asPath;
      }
      await router.push(combinePathAndQuery('/login', router.query));
    }
  }, [clearUser, router]);

  return (error: Error) => {
    // FIXME: ignoreError인데 왜 login page로 redirect 될까? ignore라면 아무 액션을 하지 않아야 하는 것이 아닐까?
    // 이 로직 전체를 건드리는 것은 side effect가 클 것 같아서,
    // 일단 개별 네트워크 요청 단에서의 처리를 한다.
    if (error instanceof CanceledError && error.config?.signal) {
      const { signal } = error.config;
      if (
        signal instanceof AbortSignal &&
        signal.reason === TranslationAbortController.ABORT_REASON
      ) {
        return;
      }
    }

    if (isIgnoreError(error)) {
      void goLoginPage();
    }
  };
};
